// Player/avatar color helpers built on shared family definitions.

import type { CSSProperties } from 'react';
import {
  PLAYER_COLOR_FAMILIES as SHARED_PLAYER_COLOR_FAMILIES,
  PLAYABLE_PLAYER_COLOR_FAMILIES as SHARED_PLAYABLE_PLAYER_COLOR_FAMILIES,
  type PlayerColorFamily as SharedPlayerColorFamily,
} from '@airhead-games/shared/configs';
import { COLOR_STOPS, getColorStop, type ColorStop } from './colorStops';
export { getColorStop };
export type { ColorFamily, ColorStop } from './colorStops';

export const PLAYER_COLOR_FAMILIES = SHARED_PLAYER_COLOR_FAMILIES;
export type PlayerColorFamily = SharedPlayerColorFamily;

export const PLAYER_COLOR_STOPS = COLOR_STOPS;
export type PlayerColorStop = ColorStop;

export type AvatarPalette = {
  light: string;
  base: string;
  dark: string;
};

export const isPlayerColorFamily = (
  value: string
): value is PlayerColorFamily =>
  PLAYER_COLOR_FAMILIES.includes(value as PlayerColorFamily);

export const getAvatarPalette = (family: PlayerColorFamily): AvatarPalette => ({
  light: getColorStop(family, '100'),
  base: getColorStop(family, '300'),
  dark: getColorStop(family, '900'),
});

export const PLAYABLE_FAMILIES = SHARED_PLAYABLE_PLAYER_COLOR_FAMILIES;

export function resolvePlayerPalette(
  player?: { playerColor?: string } | null
): { family: PlayerColorFamily; palette: AvatarPalette } {
  const normalizedFamily = player?.playerColor ?? '';
  const family: PlayerColorFamily = isPlayerColorFamily(normalizedFamily)
    ? normalizedFamily
    : 'lime';
  return { family, palette: getAvatarPalette(family) };
}

export function playerColorVars(palette: AvatarPalette): CSSProperties {
  return {
    ['--balloon-fill-light' as string]: palette.light,
    ['--balloon-fill' as string]: palette.base,
    ['--balloon-fill-dark' as string]: palette.dark,
  };
}
